import { type SVGProps } from 'react'

export default function FourthDimensionLogo({
	...props
}: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 3472.25 2741.6"
			{...props}
		>
			<g id="Capa_1" data-name="Capa 1">
				<path
					fill={props.fill ?? '#1d1d1b'}
					d="M1117.02,2051.4V654.3L106.7,2051.4h1010.32ZM0,2118.08L1257.06,384.22h46.68v1667.18h452.38l3.32,6.66-23.33,43.35c-16.68,33.33-43.35,46.68-80.02,46.68h-352.34v170.05c0,306.76,40.01,363.45,133.38,386.79v36.68h-453.47v-36.68c93.36-23.34,133.38-80.02,133.38-386.79v-166.72H16.67l-16.67-33.34Z"
				/>
			</g>
			<g id="Capa_2" data-name="Capa 2">
				<path
					fill={props.fill ?? '#1d1d1b'}
					d="M2188.51,0h-760.24v36.68c93.36,23.35,133.37,80.02,133.37,386.79v1483.39h186.73V43.36h326.77c746.9,0,1187.03,536.82,1187.03,1183.69s-346.77,1060.32-983.63,1060.32h-850.26v46.69h840.26c733.55,0,1207.04-526.83,1203.7-1207.04C3468.9,530.17,3055.44,0,2188.51,0"
				/>
			</g>
			<g id="Capa_3" data-name="Capa 3">
				<path
					fill={props.fill ?? '#1d1d1b'}
					d="M1746.69,2669.24c-9.41,42.66-40.02,72.36-90.33,72.36-61.19,0-94.72-46.17-94.72-110.62s34.42-110.33,95.6-110.33c48.26,0,79.15,29.13,88.57,72.39h-20.59c-8.84-35.61-36.2-53.56-68.55-53.56-42.38,0-74.15,32.65-74.15,91.5s30.3,91.79,74.15,91.79c40.88,0,62.95-25.89,69.43-53.54h20.59Z"
				/>
			</g>
			<g id="Capa_4" data-name="Capa 4">
				<path
					fill={props.fill ?? '#1d1d1b'}
					d="M1839.51,2524.49h136.81v18.23h-117.1v75.32h110.02v18.54h-110.02v82.97h117.1v18.23h-136.81v-213.3Z"
				/>
			</g>
			<g id="Capa_5" data-name="Capa 5">
				<path
					fill={props.fill ?? '#1d1d1b'}
					d="M2151.26,2643.05c-2.67.31-5.6.59-8.84.59h-52.08v94.15h-19.71v-213.3h62.68c50.89,0,87.07,9.11,87.07,58.54,0,35.61-18.83,52.08-48.53,57.68l51.77,97.08h-22.07l-50.29-94.74ZM2090.35,2542.44v83.26h45.62c35.3,0,63.83-4.41,63.83-42.07s-28.53-41.19-63.83-41.19h-45.62Z"
				/>
			</g>
			<g id="Capa_6" data-name="Capa 6">
				<path
					fill={props.fill ?? '#1d1d1b'}
					d="M2375.29,2524.49h22.36l81.21,213.3h-21.48l-20.31-53.56h-101.49l-20,53.56h-21.19l80.9-213.3ZM2342.35,2666h87.67l-44.12-117.1-43.55,117.1Z"
				/>
			</g>
			<g id="Capa_7" data-name="Capa 7">
				<path
					fill={props.fill ?? '#1d1d1b'}
					d="M2654.97,2737.79l-72.39-194.47v194.47h-19.71v-213.3h31.77l70.62,190.94,70.31-190.94h31.49v213.3h-19.71v-194.47l-72.39,194.47h-20Z"
				/>
			</g>
			<g id="Capa_8" data-name="Capa 8">
				<path
					fill={props.fill ?? '#1d1d1b'}
					d="M2896.04,2737.79h-19.71v-213.3h19.71v213.3Z"
				/>
			</g>
			<g id="Capa_9" data-name="Capa 9">
				<path
					fill={props.fill ?? '#1d1d1b'}
					d="M3176.95,2669.24c-9.41,42.66-40.02,72.36-90.31,72.36-61.21,0-94.74-46.17-94.74-110.62s34.42-110.33,95.63-110.33c48.24,0,79.13,29.13,88.55,72.39h-20.59c-8.82-35.61-36.18-53.56-68.55-53.56-42.36,0-74.15,32.65-74.15,91.5s30.32,91.79,74.15,91.79c40.9,0,62.97-25.89,69.43-53.54h20.59Z"
				/>
			</g>
			<g id="Capa_10" data-name="Capa 10">
				<path
					fill={props.fill ?? '#1d1d1b'}
					d="M3332.16,2520.65c42.36,0,71.48,20.31,79.44,57.08h-20.61c-7.34-24.72-27.94-38.25-60.9-38.25-21.17,0-51.77,8.53-51.77,36.49,0,21.48,17.35,32.06,41.19,37.66l25.29,5.58c30.6,7.08,71.79,19.14,71.79,60.04s-37.35,62.36-78.85,62.36c-53.25,0-82.66-29.7-87.38-67.95h20.59c7.36,34.42,30.6,49.13,65.9,49.13,23.24,0,59.13-8.51,59.13-40.31,0-25.89-25.29-38.23-55.3-44.72l-26.79-5.89c-27.94-6.17-55.89-20-55.89-55.01,0-39.14,39.71-56.2,74.15-56.2Z"
				/>
			</g>
		</svg>
	)
}
